export default __webpack_public_path__ + "static/media/Roboto-Medium.57b8a81c.woff2";